/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';
import 'src/locales/i18n';

// ----------------------------------------------------------------------

import Router from 'src/routes';

import { useScrollToTop } from '@syntra/ui/hooks/use-scroll-to-top';

import ThemeProvider from '@syntra/ui/theme';

import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from '@syntra/ui/components/animate/motion-lazy';
import { SettingsDrawer, SettingsProvider } from '@syntra/ui/components/settings';

import { AuthProvider } from 'src/auth/context/auth0';
import { FeatureFlagsProvider } from 'src/auth/feature-flags';
import { PermissionsProvider } from 'src/auth/permissions';
// -- locales
import { LocalizationProvider } from 'src/locales';

import { SnackbarProvider } from '@syntra/ui/components/snackbar';
import { APIConfigProvider } from './components/api-configs/context/api-config-provider';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();
  return (
    <AuthProvider>
      <PermissionsProvider>
        <FeatureFlagsProvider>
          <LocalizationProvider>
            <APIConfigProvider>
              <SettingsProvider
                defaultSettings={{
                  themeMode: 'light', // 'light' | 'dark'
                  themeDirection: 'ltr', //  'rtl' | 'ltr'
                  themeContrast: 'default', // 'default' | 'bold'
                  themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
                  themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
                  themeStretch: false,
                }}
              >
                <ThemeProvider>
                  <MotionLazy>
                    <SnackbarProvider>
                      <SettingsDrawer />
                      <ProgressBar />
                      <Router />
                    </SnackbarProvider>
                  </MotionLazy>
                </ThemeProvider>
              </SettingsProvider>
            </APIConfigProvider>
          </LocalizationProvider>
        </FeatureFlagsProvider>
      </PermissionsProvider>
    </AuthProvider>
  );
}
